class GateEvent {

	get UNLOCK() { return 'gateUnlock'; }
	get LOCK() { return 'gateLock'; }
	get CANCEL() { return 'cancel'; }

}

export default new GateEvent();
